import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap/alert';
import { NgxPaginationModule } from 'ngx-pagination';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { MomentModule } from 'ngx-moment';
// import { Ng2CompleterModule } from "ng2-completer"; //Unuse in project
import { ToastrModule } from 'ngx-toastr';
import { NgxUploaderModule } from 'ngx-uploader';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ModalModule,
    AlertModule,
    NgxPaginationModule,
    MomentModule,
    BsDropdownModule,
    PopoverModule,
    ToastrModule,
    NgxUploaderModule,
    TranslateModule
  ],
})
export class SharedModule {}
